export const MONITORING_SERVICE_ENDPOINT = window.env.VUE_APP_MONITORING_SERVICE_URL;

// resource paths
export const LOG_RESOURCE_PATH = '/log';
